export function FaqItem({ q, a }: { q: string; a: string }) {
  return (
    <details className="group py-4">
      <summary className="flex cursor-pointer list-none items-center justify-between gap-4 font-medium tracking-tight">
        {q}
        <span className="grid size-6 place-items-center rounded-full bg-muted text-muted-foreground transition-transform group-open:rotate-45">
          +
        </span>
      </summary>
      <p
        className="mt-3 text-sm leading-relaxed text-muted-foreground"
        dangerouslySetInnerHTML={{ __html: a }}
      />
    </details>
  )
}
